<!--Topbar before login-->
        <div id="header-main" class="header-main"  *ngIf="!sessionLoginStatus"> 
          <!-- Horizontal Header -->
            <div class="horizontal-header clearfix ">
                <div class="container">
                    <a id="horizontal-navtoggle" class="animated-arrow"><span></span></a>
                    <span class="smllogo"><img src="assets/images/brand/logo.png" width="120" alt=""/></span>
                    <a href="tel:245-6325-3256" class="callusbtn"><i class="fa fa-phone" aria-hidden="true"></i></a>
                </div>
            </div>
            <!-- /Horizontal Header -->

            <!-- Horizontal Main -->
            <div class="horizontal-main horizontal-main bg-dark-transparent clearfix">
                <div class="horizontal-mainwrapper container clearfix">
                    <div class="desktoplogo">
                        <a><img src="assets/images/brand/logo.png" alt="" class="cursor_pointer" (click)="home()"></a>
                    </div>
                    <div class="desktoplogo-1">
                        <a><img src="assets/images/brand/logo.png" alt="" class="cursor_pointer" (click)="home()"></a>
                    </div>
                    <!--Nav-->
                    
                    <nav class="horizontalMenu clearfix d-md-flex ">
                        <div class="outsidebg  col-xl-4"></div>
                        <ul class="horizontalMenu-list col-xl-8 col-lg-8">
                            <li aria-haspopup="true" *ngIf="page==='visitor-contactus'"><a (click)="visitor()" class="cursor_pointer">Home</a></li>
							<li aria-haspopup="true" *ngIf="page==='visitor' || page===''"><a href="#howItWorks"  class="cursor_pointer">  How it works  <span class="horizontalarrow"></span></a></li>
                            <li aria-haspopup="true"><a (click)="visitorcContactUs()" [ngClass]="{active: page==='visitor-contactus'}"  class="cursor_pointer"> Contact Us <span class="horizontalarrow cursor_pointer"></span></a></li>
							<li aria-haspopup="true"><a class="cursor_pointer" (click)="resetJoinUsForm()" onclick="$('#login-popup').modal('show');" > Login/Join us <span class="horizontalarrow"></span></a></li>
                            <li aria-haspopup="true"><a href="javascript:void(0)" class="request_tour"  data-toggle="modal" data-target="#exampleModal4" (click)="resetVisitorRegForm();"><span>Request a Tour </span></a> </li>                      
                        </ul>
                    </nav>
                    <!--Nav-->
                </div>
            </div>
            <!-- /Horizontal Main -->
        </div>
        <!--/Topbar before login-->

<!--Topbar after login-->
        <div class="header-main" id="header-main" *ngIf="sessionLoginStatus">
            

            <!-- Horizontal Header -->
            <div class="horizontal-header clearfix ">
                <div class="container">
                    <a id="horizontal-navtoggle" class="animated-arrow"><span></span></a>
                    <span class="smllogo"><img src="assets/images/brand/logo.png" width="120" alt=""/></span>
                    <a href="tel:245-6325-3256" class="callusbtn"><i class="fa fa-phone" aria-hidden="true"></i></a>
                </div>
            </div>
            <!-- /Horizontal Header -->

            <!-- Horizontal Main -->
          <!-- Horizontal Main -->
            <div class="horizontal-main horizontal-main bg-dark-transparent clearfix">
                <div class="horizontal-mainwrapper container clearfix">
                    <div class="desktoplogo">
                        <a><img src="assets/images/brand/logo.png" alt="" (click)="home()"></a>
                    </div>
                    <div class="desktoplogo-1">
                        <a><img src="assets/images/brand/logo.png" alt="" (click)="home()"></a>
                    </div>
                    <!--Nav-->
                    <nav class="horizontalMenu clearfix d-md-flex">
                        <ul class="horizontalMenu-list col-md-8 col-xl-9 ">
                            <li aria-haspopup="true"><a (click)="home()"  [ngClass]="{active: page==='home'}" [ngClass]="{active: page===''}" class="cursor_pointer close-cl">Home</a></li>
                            <!--li aria-haspopup="true"><a href="about.html">About Us </a></li-->

							<li aria-haspopup="true" class="buy-car dropdown"><a  class="cursor_pointer" [ngClass]="{active: page==='fixed-price-cars'}" [ngClass]="{active: page==='auction-cars'}"  data-toggle="dropdown"><i class="fa fa-car  mr-1"></i>Used Cars for Sale </a>
								
                            <div class="horizontal-megamenu clearfix car-brands">
                                    <div class="container">
                                        <div class="megamenu-content overflow-hidden">
                                            <div class="row">
                                                <ul class="link-list">
                                                    <li>
                                                       <a class="dropdown-item cursor_pointer close-cl" (click)="fixedPriceCars()">Buy Now Cars 	</a></li>
                                                     <li>
                                                       <a class="dropdown-item cursor_pointer close-cl" (click)="auctionCars()">Okshan Cars</a>
                                                    </li>
                                                </ul>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                            </li>
                            
                            	<li aria-haspopup="true" class="buy-car dropdown" *ngIf="actionStatus && (sessionProfileType==0 || sessionProfileType==2)">
                                <a *ngIf="sessionLoginStatus"  [ngClass]="{active: page==='sell-car'}" class="" class="cursor_pointer" data-toggle="dropdown"><i class="fa fa-car  mr-1"></i> Sell Your Car</a>
                                <a *ngIf="!sessionLoginStatus" class="cursor_pointer "  data-toggle="dropdown" onclick="$('#login-popup').modal('show');"><i class="fa fa-car  mr-1"></i> Sell Your Car</a>
								
                            <div class="horizontal-megamenu clearfix car-brands">
                                    <div class="container">
                                        <div class="megamenu-content overflow-hidden">
                                            <div class="row">
                                                <ul class="link-list">
                                                    <li>
                                                    <a *ngIf="sessionLoginStatus"  (click)="sellCar(1)" class="cursor_pointer dropdown-item close-cl" >Fixed Price</a>
                                                    <a *ngIf="!sessionLoginStatus"  onclick="$('#login-popup').modal('show');" class="dropdown-item cursor_pointer close-cl" >Fixed Price</a>
                                                    </li>
                                                     <li>
                                                     <a *ngIf="sessionLoginStatus"  class="dropdown-item cursor_pointer close-cl" (click)="sellCar(2)">Okshan Cars</a>
                                                     <a *ngIf="!sessionLoginStatus"  class="dropdown-item cursor_pointer close-cl" onclick="$('#login-popup').modal('show');">Okshan Cars</a>
                                                     </li>
                                                </ul>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                            </li>
                            
                            <!--li aria-haspopup="true"><a href="blog.html">Blog</a>								
                            </li-->
						 <!--<li aria-haspopup="true" class="  d-lg-block dropdown">-->
       <!--                        <a class=" " href="sell-car.html" data-toggle="dropdown"><i class="fa fa-car  mr-1"></i> Sell Your Car</a>-->
							<!--   <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow">-->
							<!--			<a href="sell-car.html" class="dropdown-item" >Fixed Price</a>-->
							<!--			<a class="dropdown-item" href="sell-car.html">Okshan Cars-->
							<!--			</a>-->
							<!--	</div>-->
       <!--                     </li>-->
                           <li aria-haspopup="true"><a (click)="howItsWork()" [ngClass]="{active: page==='how-its-work'}"  class="cursor_pointer close-cl">  How it works  <span class="horizontalarrow"></span></a></li>
                            <li aria-haspopup="true"><a (click)="visitorcContactUs()" [ngClass]="{active: page==='visitor-contactus'}" class="cursor_pointer close-cl"> Contact Us <span class="horizontalarrow"></span></a></li>
                            <li aria-haspopup="true" *ngIf="sessionProfileType==-1"><a class="cursor_pointer" (click)="resetJoinUsForm()" onclick="$('#company-register-popup').modal('show');" ><i class="fa fa-user mr-1"></i> Join Us <span class="horizontalarrow"></span></a></li>
                           <li *ngIf="sessionLoginStatus && sessionProfileType>-1" class="none-dis dropdown"><a  data-toggle="dropdown" class="cursor_pointer"><i class="fa fa-home mr-1"></i><span>Welcome {{sessionFirstName}}</span></a>
                                        <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                                            <a  class="dropdown-item cursor_pointer close-cl" (click)="myProfile()">
                                                <i class="dropdown-icon fa fa-user"></i> My Profile
                                            </a>
                                            <a class="dropdown-item  cursor_pointer close-cl" *ngIf="sessionProfileType==0 || sessionProfileType==2"  (click)="myCars()">
                                                <i class="dropdown-icon fa fa-car"></i> My Cars
                                            </a>
                                            <a class="dropdown-item cursor_pointer close-cl" (click)="myPreference()"  *ngIf="sessionProfileType==0 || sessionProfileType==2">
                                                <i class="dropdown-icon fa fa-thumbs-up"></i> My Preferences
                                            </a>
                                            <a class="dropdown-item close-cl"  *ngIf="sessionProfileType==0 || sessionProfileType==2">
                                                <i class="dropdown-icon fa fa-list"></i> My Orders
                                            </a>
                                            <a class="dropdown-item close-cl"  *ngIf="sessionProfileType==0 || sessionProfileType==2">
                                                <i class="dropdown-icon fa fa-registered"></i> RC Status
                                            </a>
                                            <!--<a class="dropdown-item" href="my-favorite.html">-->
                                            <!--    <i class="dropdown-icon fa fa-heart"></i> My Favorites-->
                                            <!--</a>-->
                                            <a class="dropdown-item close-cl cursor_pointer"  *ngIf="sessionProfileType==1 || sessionProfileType==2" (click)="myInspection()">
                                                <i class="dropdown-icon fa fa-align-justify"></i> My Inspections
                                            </a>
                                            <a class="dropdown-item cursor_pointer close-cl"  *ngIf="sessionProfileType==0 || sessionProfileType==2" (click)="myPaymentHistory()">
                                                <i class="dropdown-icon fa fa-history"></i> Payment History
                                            </a>
                                            <a class="dropdown-item close-cl">
                                                <i class="dropdown-icon fa fa-ticket"></i> Tickets
                                            </a>                                                                                                                                                                             
                                            <!-- <a class="dropdown-item close-cl" >
                                                <i class="dropdown-icon  fa fa-question close-cl"></i> Help & Support
                                            </a> -->
                                            <a class="dropdown-item cursor_pointer " (click)="logout()">
                                                <i class="dropdown-icon fa fa-power-off"></i> Log out
                                            </a>
                                        </div>
                                    </li>
                                        <li style="display:none;"  class="none-dis" class="position_set"><a   data-toggle="dropdown"><i class="fa fa-bell mr-1"></i> </a>
                                        <span class="nav-unread badge badge-danger badge-pill" >4</span>

                                        <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                                            <a  class="dropdown-item text-center">You have 4 notification</a>
                                            <div class="dropdown-divider"></div>
                                            <a  class="dropdown-item d-flex pb-3">
                                                <div class="notifyimg">
                                                    <i class="fa fa-user"></i>
                                                </div>
                                                <div>
                                                    <strong>Your Profile has been approved by the admin</strong>
                                                    <div class="small text-muted">19-Jan 17:50 Pm</div>
                                                </div>
                                            </a>
                                            <a  class="dropdown-item d-flex pb-3">
                                                <div class="notifyimg">
                                                    <i class="fa fa-ban"></i>
                                                </div>
                                                <div>
                                                    <strong>Evaluation Report has been rejected by the RE</strong>
                                                    <div class="small text-muted">19-Jan 17:50 Pm</div>
                                                </div>
                                            </a>
                                            <a  class="dropdown-item d-flex pb-3">
                                                <div class="notifyimg">
                                                    <i class="fa fa-check"></i>
                                                </div>
                                                <div>
                                                    <strong>Auction is approved by the Auction Officer</strong>
                                                    <div class="small text-muted">19-Jan 17:50 Pm</div>
                                                </div>
                                            </a>
                                            <a  class="dropdown-item d-flex pb-3">
                                                <div class="notifyimg">
                                                    <i class="fa fa-close"></i>
                                                </div>
                                                <div>
                                                    <strong>Ticket ID 2345 has been closed by the Support Team</strong>
                                                    <div class="small text-muted">19-Jan 17:50 Pm</div>
                                                </div>
                                            </a>
                                            <div class="dropdown-divider"></div>
                                            <a  class="dropdown-item text-center">See all Notification</a>
                                        </div>
                                    </li>                                    
                               
                        </ul>
                           <ul  class="join-menu horizontalMenu-list col-md-4 col-xl-3">
                                    <li *ngIf="sessionProfileType==-1"  class="none-dis" aria-haspopup="true"><a (click)="resetJoinUsForm()" class="cursor_pointer"  data-toggle="modal" data-target="#login-popup"><i class="fa fa-user mr-1"></i> Join Us<span class="horizontalarrow"></span></a></li>
                                    <li  *ngIf="sessionLoginStatus && sessionProfileType==-1" class="dropdown"><a  data-toggle="dropdown" class="cursor_pointer"><i class="fa fa-home mr-1"></i><span>Welcome {{sessionFirstName}}</span></a>
                                        <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                                            <a class="dropdown-item cursor_pointer" (click)="logout()">
                                                <i class="dropdown-icon fa fa-power-off"></i> Log out
                                            </a>
                                        </div>
                                    </li>
                                    <li  *ngIf="sessionLoginStatus && sessionProfileType>-1" class="dropdown"><a  data-toggle="dropdown" class="cursor_pointer"><i class="fa fa-home mr-1"></i><span>Welcome {{sessionFirstName}}</span></a>
                                        <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                                            <a class="dropdown-item cursor_pointer" (click)="myProfile()" >
                                                <i class="dropdown-icon fa fa-user"></i> My Profile
                                            </a>
                                            <a class="dropdown-item cursor_pointer" *ngIf="sessionProfileType==0 || sessionProfileType==2" (click)="myCars()">
                                                <i class="dropdown-icon fa fa-car"></i> My Cars
                                            </a>
                                            <a class="dropdown-item cursor_pointer"  (click)="myPreference()" *ngIf="sessionProfileType==0 || sessionProfileType==2">
                                                <i class="dropdown-icon fa fa-thumbs-up"></i> My Preferences
                                            </a>
                                            <a class="dropdown-item" *ngIf="sessionProfileType==0 || sessionProfileType==2">
                                                <i class="dropdown-icon fa fa-list"></i> My Orders
                                            </a>
                                            <a class="dropdown-item" *ngIf="sessionProfileType==0 || sessionProfileType==2">
                                                <i class="dropdown-icon fa fa-registered"></i> RC Status
                                            </a>
                                            <!--<a class="dropdown-item" href="my-favorite.html">-->
                                            <!--    <i class="dropdown-icon fa fa-heart"></i> My Favorites-->
                                            <!--</a>-->
                                            <a class="dropdown-item cursor_pointer" *ngIf="sessionProfileType==1 || sessionProfileType==2" (click)="myInspection()">
                                                <i class="dropdown-icon fa fa-align-justify"></i> My Inspections
                                            </a>
                                            <a class="dropdown-item cursor_pointer" *ngIf="sessionProfileType==0 || sessionProfileType==2"  (click)="myPaymentHistory()">
                                                <i class="dropdown-icon fa fa-history"></i> Payment History
                                            </a>
                                            <a class="dropdown-item">
                                                <i class="dropdown-icon fa fa-ticket"></i> Tickets
                                            </a>                                                                                                                                                                             
                                            <!-- <a class="dropdown-item" >
                                                <i class="dropdown-icon  fa fa-question"></i> Help & Support
                                            </a> -->
                                            <a class="dropdown-item cursor_pointer" (click)="logout()">
                                                <i class="dropdown-icon fa fa-power-off"></i> Log out
                                            </a>
                                        </div>
                                    </li>
                                        <li *ngIf="sessionLoginStatus && sessionProfileType>-1" class="position_set"><a   data-toggle="dropdown"><i class="fa fa-bell mr-1"></i> </a>
                                        <span class="nav-unread badge badge-danger badge-pill" >4</span>

                                        <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                                            <a  class="dropdown-item text-center">You have 4 notification</a>
                                            <div class="dropdown-divider"></div>
                                            <a  class="dropdown-item d-flex pb-3">
                                                <div class="notifyimg">
                                                    <i class="fa fa-user"></i>
                                                </div>
                                                <div>
                                                    <strong>Your Profile has been approved by the admin</strong>
                                                    <div class="small text-muted">19-Jan 17:50 Pm</div>
                                                </div>
                                            </a>
                                            <a  class="dropdown-item d-flex pb-3">
                                                <div class="notifyimg">
                                                    <i class="fa fa-ban"></i>
                                                </div>
                                                <div>
                                                    <strong>Evaluation Report has been rejected by the RE</strong>
                                                    <div class="small text-muted">19-Jan 17:50 Pm</div>
                                                </div>
                                            </a>
                                            <a  class="dropdown-item d-flex pb-3">
                                                <div class="notifyimg">
                                                    <i class="fa fa-check"></i>
                                                </div>
                                                <div>
                                                    <strong>Auction is approved by the Auction Officer</strong>
                                                    <div class="small text-muted">19-Jan 17:50 Pm</div>
                                                </div>
                                            </a>
                                            <a  class="dropdown-item d-flex pb-3">
                                                <div class="notifyimg">
                                                    <i class="fa fa-close"></i>
                                                </div>
                                                <div>
                                                    <strong>Ticket ID 2345 has been closed by the Support Team</strong>
                                                    <div class="small text-muted">19-Jan 17:50 Pm</div>
                                                </div>
                                            </a>
                                            <div class="dropdown-divider"></div>
                                            <a  class="dropdown-item text-center">See all Notification</a>
                                        </div>
                                    </li>
                                    <li  [style.display]="!sessionLoginStatus ? 'block' : 'none'"  aria-haspopup="true"><a (click)="resetJoinUsForm()" class="cursor_pointer" data-toggle="modal" data-target="#login-popup"><i class="fa fa-user mr-1"></i> Join Us<span class="horizontalarrow"></span></a></li>
                                </ul>
                        <ul class="mb-0">
                           
                        </ul>
                    </nav>
                    <!--Nav-->
                </div>
            </div>
            <!-- /Horizontal Main -->
        </div>
        <!--/Topbar after login-->

        <!-- loader -->
        <div id="global-loader" [style.display]="!isLoading ? 'block' : 'none'">
            <img src="assets/images/loader.svg" class="loader-img " alt="">
        </div>
        <!-- /loader -->

        <!-- reqest a tour-->
        <div class="modal fade" id="exampleModal4" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"  aria-hidden="true">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
                    
					<div class="table-responsive my-preference-popup">
							
                      
                    <div class="card m-b-20">
                    <div class="modal-header border-bottom-0">
                <a class="close btn btn-sm btn-success" data-dismiss="modal" aria-label="Close">
                            <i class="fa fa-times"></i>
                        </a>
                </div>
									<div class="card-header register-okshan text-center">
										<h2 class=" w-100"> Lets get you started with <span class="color-green">OKSHAN</span></h2>
										<p>Please share few details about yourself</p>
									</div>
									<div class="card-body">
										<form [formGroup]="visitorRegFormGroup" (ngSubmit)="proceedRegistration(visitorRegFormGroup.value)"  class="form-row">
										    <div class="col-md-12" *ngIf="eventStatusMsg!=''"><label style="color:red">{{eventStatusMsg}}</label></div>
                                            <div class="col-md-9">
										    	<div class="form-group">
                                                <div style="display:flex;">	
                                                <span style="color:red;"></span>											
												<input type="text" value="+91" class="form-control" style="width:15%" readonly>
                                                <input formControlName="visitorRegMobile" type="text" class="form-control"  style="width:85%" id="exampleInputnumber" placeholder="Enter Phone number*">
											    </div>
                                                 <div *ngIf="visitorRegFormGroup.get('visitorRegMobile').errors && (visitorRegFormGroup.controls.visitorRegMobile.dirty || visitorRegFormGroup.controls.visitorRegMobile.touched || isVisitorRegSubmit)">
                                                <div *ngIf="visitorRegFormGroup.get('visitorRegMobile').hasError('required')">
                                                <span style="color: red;">Enter mobile number</span>
                                                </div>
                                                <div *ngIf="visitorRegFormGroup.get('visitorRegMobile').hasError('pattern') || visitorRegFormGroup.get('visitorRegMobile').hasError('maxlength')">
                                                <span style="color: red;">Enter 10 digit valid mobile number</span>
                                                </div>
                                                </div>
                                                </div>
                                                
											</div>
											<div class="col-md-3 col-sm-3">
    										    <div class="form-group">
    												<div class="checkbox checkbox-secondary">                                                    
    													<label *ngIf="!getOtpVisitorBtnStatus && counter>0 && !isOtpConfirmed" style="color: red;">{{counterLabel}} </label>
                                                        <a *ngIf="getOtpVisitorBtnStatus && !isOtpConfirmed" class="otp-btn" href="javascript:void(0)" (click)="proceedVisitorRegOtpOnMobile(visitorRegFormGroup.value)">Get OTP</a>
    												</div>
    											</div>
											</div>
											 <div class="col-md-9">
    											<div class="form-group">
                                                    <div style="display:flex;">
                                                    <span style="color:red; "></span>
    												<input formControlName="visitorRegMobileOtp" type="text" class="form-control" id="exampleInputname"  placeholder="Enter OTP*">
    											    </div>
                                                    <div *ngIf="visitorRegFormGroup.get('visitorRegMobileOtp').errors && (visitorRegFormGroup.controls.visitorRegMobileOtp.dirty || visitorRegFormGroup.controls.visitorRegMobileOtp.touched || isVisitorRegSubmit)">
                                                <span style="color: red;">Enter otp</span>
                                                </div>
                                                <div *ngIf="!isOtpConfirmed && !visitorRegFormGroup.get('visitorRegMobileOtp').errors && (visitorRegFormGroup.controls.visitorRegMobileOtp.dirty || visitorRegFormGroup.controls.visitorRegMobileOtp.touched || isVisitorRegSubmit)">
                                                <span style="color: red;">{{otpConfimedLabel}}</span>
                                                </div>
                                                </div>
											</div>
											<div class="col-md-3  col-sm-3">
    										    <div class="form-group">
    												<div class="checkbox checkbox-secondary">
    													<a class="otp-btn" href="javascript:void(0)" (click)="proceedConfirmRegOtpOnMobile(visitorRegFormGroup.value)">Verify OTP</a>
    												</div>
    											</div>
											</div>
											
											 <div class="col-md-12" style="display:none;">
    											<div class="form-group">
                                                    <div style="display:flex;">
    												<span style="color:red;"></span>
    												<input formControlName="visitorRegDealership" type="text" class="form-control" id="exampleInputEmail2" placeholder="Dealership Name*">
    											    </div>
                                                    <div *ngIf="visitorRegFormGroup.get('visitorRegDealership').errors && (visitorRegFormGroup.controls.visitorRegDealership.dirty || visitorRegFormGroup.controls.visitorRegDealership.touched || isVisitorRegSubmit)">
                                                <span style="color: red;">Enter dealership name</span>
                                                </div>
                                                </div>
											</div>
                                            <div class="col-md-6  col-sm-6">
                                       
                                        <div class="form-group" style="display:flex;">
                                            <span style="color:red;"></span>
                                            <input formControlName="visitorRegFullName" type="text" class="form-control" style="text-transform: capitalize;" placeholder="Your First Name*">
                                        </div>
                                        <div *ngIf="visitorRegFormGroup.get('visitorRegFullName').errors  && (visitorRegFormGroup.controls.visitorRegFullName.dirty || visitorRegFormGroup.controls.visitorRegFullName.touched || isVisitorRegSubmit)">  
                                        <div *ngIf="visitorRegFormGroup.get('visitorRegFullName').hasError('required')">  
                                            <span style="color: red;">Enter first name</span>  
                                        </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6  col-sm-6">
                                       
                                        <div class="form-group" style="display:flex;">
                                            <span style="color:red;"> </span>
                                            <input formControlName="visitorRegLastName" type="text" class="form-control" style="text-transform: capitalize;" placeholder="Your Last Name">
                                        </div>                                        
                                    </div>
											<div class="col-md-6  col-sm-6 select-box-state ">
    											<div class="form-group">
                                                <div style="display:flex">
                                                <span style="color:red;"></span>
    											<select  formControlName="visitorRegState" id="inputState" (change)="onChangeState($event.target.value)" class="form-control">
    														<optgroup label="States">
													<option value="0">--State*--</option>
                                                    <option *ngFor="let state of preferredStateList" value="{{state.id}}">{{state.name}}</option>
                                                    <option disabled>------------</option>
                                                    <option *ngFor="let state of otherStateList" value="{{state.id}}">{{state.name}}</option>													
												</optgroup>
    													</select>
                                                </div>        
                                                        <div *ngIf="visitorRegFormGroup.get('visitorRegState').errors && (visitorRegFormGroup.controls.visitorRegState.dirty || visitorRegFormGroup.controls.visitorRegState.touched || isVisitorRegSubmit)">
                                                <div *ngIf="visitorRegFormGroup.get('visitorRegState').hasError('min')">
                                                <span style="color: red;">Select state</span>
                                                </div>
                                                </div>
    											</div>
											</div>
											<div class="col-md-6  col-sm-6 select-box-state">
    											<div class="form-group">
                                                <div style="display:flex">
                                                        <span style="color:red;"></span>
    													<select  formControlName="visitorRegCity" id="inputcity" class="form-control">
    														<option value="0">City*</option>
    														<option *ngFor="let city of cityList" value="{{city.id}}">{{city.name}}</option>
    													</select>
                                                </div>        
                                                        <div *ngIf="visitorRegFormGroup.get('visitorRegCity').errors && (visitorRegFormGroup.controls.visitorRegCity.dirty || visitorRegFormGroup.controls.visitorRegCity.touched || isVisitorRegSubmit)">
                                                <div *ngIf="visitorRegFormGroup.get('visitorRegCity').hasError('min')">
                                                <span style="color: red;">Select city</span>
                                                </div>
                                                </div>
    											</div>
											</div>
										<div class="col-md-12">
										<div class="form-group">
                                            <div style="display:flex">
                                                <span style="color:red; "></span>
												<input  formControlName="visitorRegEmail" type="email" class="form-control" id="exampleInputname"  placeholder="Enter email*">
											</div>    
                                                <div *ngIf="visitorRegFormGroup.get('visitorRegEmail').errors && (visitorRegFormGroup.controls.visitorRegEmail.dirty || visitorRegFormGroup.controls.visitorRegEmail.touched || isVisitorRegSubmit)">
                                                <div *ngIf="visitorRegFormGroup.get('visitorRegEmail').hasError('required')">
                                                <span style="color: red;">Enter email</span>
                                                </div>                                                
                                                <div *ngIf="visitorRegFormGroup.get('visitorRegEmail').hasError('pattern')">
                                                <span style="color: red;">Enter valid email</span>
                                                </div>
                                                </div>
                                            </div>
										</div>
                                        <div class="col-md-12">
                                        <div class="form-group" style="display:flex;">
                                            <span style="color:red; "></span>
                                            <div class="join_us_tc"><input (change)="onChangeTerm($event)" type="checkbox" value="true"/> <label><a href="#/term-condition" target="_blank">I accept the terms & privacy policies</a></label></div> 
                                            <!-- <div  *ngIf="visitorRegFormGroup.get('visitorRegTerm').value != true && (visitorRegFormGroup.controls.visitorRegTerm.dirty || visitorRegFormGroup.controls.visitorRegTerm.touched)">  
                                            <span style="color: red;">Accept the terms & privacy policies</span>                                          
                                            </div> -->
                                        </div>                                        
                                       </div>	
											<div class="form-group mb-0">
												<div class="checkbox checkbox-secondary">                                                
													<button [disabled] = "requestInProcess" type="submit" class="btn btn-primary" style="margin-left:11px">Submit</button>
												</div>
											</div>
										</form>
									</div>
								</div>
                                    

								
								
                                
                  </div>
						
					</div>
				</div>
			</div>
            <button style="display:none;" #visitorRegBoxCloseBtn onclick="$('#exampleModal4').modal('hide');"></button> 
            <!-- /reqest a tour-->
